import { localQueryEntityOptions } from '@app/icare/client/db/client/localQueryOneOptions'
import { sync } from '@app/icare/client/sync'
import { PatientFormId, type PatientFormIdType } from '@app/icare/db/schema/form/PatientFormCommon'
import { PatientFormTypeEnum } from '@app/icare/db/schema/form/PatientFormType'
import { PatientMasterDataSheetSchema } from '@app/icare/db/schema/form/PatientMasterDataSheet'
import type { PatientIdType } from '@app/icare/entities/patient/schema/Patient'

import { appFormOptions } from '@app/icare/form/appFormOptions'
import { useAppForm } from '@app/icare/form/useAppForm'
import { t } from '@lingui/core/macro'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { Form } from 'antd'
import { NewMasterDataSheet } from './-new'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_documents/_forms/stammblatt/new')({
  component: RouteComponent,
  staticData: {
    layout: {
      menuRender: false,
    },
  },
})

function RouteComponent() {
  const router = useRouter()
  const { form: formId, id: patientId } = Route.useParams() as {
    id: PatientIdType
    form: PatientFormIdType | 'new'
  }

  const current = useQuery(localQueryEntityOptions(formId))

  const form = useAppForm(
    appFormOptions(PatientMasterDataSheetSchema, {
      defaultValues: current.data ?? {
        id: PatientFormId.generate(),
        patientId,
        type: PatientFormTypeEnum.MasterDataSheet,
        status: 'new',
      },
      toast: { subject: t`Stammblatt` },
      onSubmit: async ({ value }) => {
        await sync.mutate(value)
        return router.navigate({
          to: '/patienten/$id/stammblatt',
          replace: true,
          params: { id: patientId },
        })
      },
    }),
  )

  return (
    <form.AppForm>
      <form.ProForm editablePolicy={{ forceMode: 'edit' }}>
        <Form component={false} layout="horizontal" labelCol={{ span: 6 }} wrapperCol={{ span: 16 }}>
          <NewMasterDataSheet />
        </Form>
      </form.ProForm>
    </form.AppForm>
  )
}
